import * as React from 'react';
import {
    ArrayField,
    BooleanField,
    CloneButton,
    ChipField,
    Datagrid,
    DateField,
    EditButton,
    NumberField,
    ReferenceArrayField,
    ReferenceManyField,
    ReferenceManyCount,
    RichTextField,
    SelectField,
    ShowContextProvider,
    ShowView,
    SingleFieldList,
    TabbedShowLayout,
    TextField,
    UrlField,
    useShowController,
    useLocaleState,
    useRecordContext,
} from 'react-admin';

const RanShow = () => {
    const controllerProps = useShowController();
    return (
    <ShowContextProvider value={controllerProps}>
       888888888
    </ShowContextProvider>
    );
}

export default RanShow;
